import React from 'react';
import LocationDropdown from './components/LocationDropdown';

function App() {
    return (
        <div className="App">
            <div className="container" role="main">
                <LocationDropdown />
            </div>
        </div>
    );
}

export default App;